<template>
  <div class="customer">
    <router-view>

    </router-view>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {};
  },
  components: {},
  methods: {},
};
</script>

<style scoped lang="less">
</style>
